import React, { useRef, useEffect, useState } from 'react';
import { Printer, Edit2, Save, X, Upload } from 'lucide-react';
import apiService from '../../config';
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const Kalam11 = () => {
  const documentRef = useRef(null);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [familyData, setFamilyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({
    category: '',
    remarks: ''
  });
  const [locationInfo, setLocationInfo] = useState({
  district: '',
  taluka: '',
  village: ''
});
const [fullName, setFullName] = useState('');
const [designation , setDesignation] =useState('');
const [showSignaturePad, setShowSignaturePad] = useState(false);
const [pdfForSigning, setPdfForSigning] = useState(null);
const [isViewerOpen, setIsViewerOpen] = useState(false);
const [viewerFile, setViewerFile] = useState(null);
const [previewUrl, setPreviewUrl] = useState(null);
const {
  uploadStatus,
  uploadError,
  selectedSignDocument,
  resetSignatureState,
  setUploadStatus,
  setUploadError,
  signDocument
} = useSignature();

useEffect(() => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  setFullName(userData.full_name || '');
  setDesignation(userData.designation || '');
}, []);



  useEffect(() => {
    const getProjectId = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        const p = JSON.parse(currentProjectData);
        return p.project_id || p.id;
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        const p = JSON.parse(selectedProject);
        return p.project_id || p.id;
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        const u = JSON.parse(userData);
        return u?.data?.project_id || u?.project_id || null;
      }
      return null;
    };

    const getProposalId = () => {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      return (
        userData?.data?.default_proposal ||
        userData?.data?.proposal_id ||
        userData?.default_proposal ||
        userData?.proposal_id ||
        null
      );
    };

    setProjectId(getProjectId());
    setProposalId(getProposalId());
  }, []);

  /* -----------------------------
     Fetch & Map Family Details
  ------------------------------*/
  useEffect(() => {
    const fetchFamilyDetails = async () => {
      if (!projectId || !proposalId) return;

      try {
        setLoading(true);
        const response = await apiService.getFamilyDetails(projectId, proposalId);

        let rawData = [];

        if (Array.isArray(response?.data)) {
          rawData = response.data;
        } else if (Array.isArray(response?.data?.data)) {
          rawData = response.data.data;
        } else if (Array.isArray(response)) {
          rawData = response;
        }

        // 🔥 Map backend response → table structure
        const mappedData = rawData.map((item, index) => ({
          measureId: item.land_owner_id,
          serial: index + 1,
          registration: item.land_owner_id || '-',
          jmr: item.survey_no || '-',
          house: item.survey_no || '-',
          dist_name:item.dist_name || '',

          members:
            item.familyDetails && item.familyDetails.length > 0
              ? item.familyDetails.map(fd => ({
                name: fd.name,
                relation: fd.relation_to_head
              }))
              : [{ name: item.owner_name, relation: 'स्वतः' }],

          family: item.familyDetails?.length || 1,
          category: item.Family_11_1_classification || '',
          remarks: item.Family_11_1_remarks || ''
        }));

        if (rawData.length > 0) {
        setLocationInfo({
          district: rawData[0].dist_name || '',
          taluka: rawData[0].taluka_name || '',
          village: rawData[0].village_name || ''
        });
      }


        setFamilyData(mappedData);
      } catch (error) {
        console.error('❌ Error fetching family details:', error);
        setFamilyData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyDetails();
  }, [projectId, proposalId]);

  const startEdit = (row) => {
    setEditingId(row.measureId);
    setEditData({
      category: row.category || '',
      remarks: row.remarks || ''
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditData({});
  };

  const handleEditChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const saveEdit = async (row) => {
    try {
      await apiService.patchUpdateMeasurement(row.measureId, {
        Family_11_1_classification: editData.category,
        Family_11_1_remarks: editData.remarks
      });

      // update table without refetch
      setFamilyData(prev =>
        prev.map(item =>
          item.measureId === row.measureId
            ? {
              ...item,
              category: editData.category,
              remarks: editData.remarks
            }
            : item
        )
      );

      setEditingId(null);
      setEditData({});
      alert('✅ माहिती यशस्वीपणे अपडेट झाली');
    } catch (err) {
      console.error(err);
      alert('❌ अपडेट करताना त्रुटी आली');
    }
  };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "Kalam11",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "Kalam11"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "Kalam11" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};
  



  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>मौजे जिगांव तालुका नांदुरा जिल्हा बुलढाणा</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 0.4in 0.3in;
            }
            
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
              font-size: 15px;
              line-height: 1.3;
              color: #000;
              margin: 0;
              padding: 0;
            }

            .text-center {
              text-align: center;
            }

            .text-right {
              text-align: right;
            }

            .font-bold {
              font-weight: bold;
            }

            .mb-2 {
              margin-bottom: 4px;
            }

            .mb-3 {
              margin-bottom: 6px;
            }

            .mt-10{
              margin-top: 40px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              border: 2px solid #000;
            }

            th, td {
              border: 1px solid #000;
              padding: 3px 5px;
              vertical-align: top;
            }

            th {
              font-weight: bold;
              text-align: center;
            }

            button {
            display: none
            }

            .noprint{
            display: none
            }

            @media print {
              body {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

  if (loading) {
    return (
      <div className="p-6 text-center font-bold">
        कुटुंबाचा तपशील लोड होत आहे...
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Print Button */}
      <div className="flex justify-start mb-6">
      {/* <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center mx-3 space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button> */}
        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg"
        >
          <Printer size={20} />
          Print
        </button>
      </div>

      {/* Document Preview */}
      <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
        <div
          ref={documentRef}
          className="document-container"
          style={{
            fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
            padding: "25px",
            fontSize: "15px",
            lineHeight: "1.4"
          }}
        >
          {/* Header */}
          <div className="flex justify-between items-start mb-3">
            <div className="text-center font-bold flex-1" style={{ fontSize: '15px' }}>
              मौजे {locationInfo.village} तालुका {locationInfo.taluka} जिल्हा {locationInfo.district}
            </div>
            <div className="text-right" style={{ fontSize: '15px', minWidth: '200px' }}>
              कलम 11 (1) दिनांक
            </div>
          </div>

          <div className="text-center mb-3" style={{ fontSize: '15px' }}>
            मौजे {locationInfo.village} तालुका {locationInfo.taluka} जिल्हा {locationInfo.district} येथील बाधित झालेले प्रकल्पप्रस्तांची कुटुंबाचा तपशील.
          </div>

          {/* Table */}
          <table className="w-full border-2 border-black">
            <thead>
              <tr className="font-bold">
                <th className="border border-black p-2" rowSpan="2" style={{ width: '40px' }}>अ.क्र.</th>
                <th className="border border-black p-2" rowSpan="2" style={{ width: '80px' }}>निवाडयातील<br />अ.क्र.</th>
                <th className="border border-black p-2" rowSpan="2" style={{ width: '80px' }}>JMR मधील<br />अनुक्रमांक</th>
                <th className="border border-black p-2" rowSpan="2" style={{ width: '60px' }}>घर क्रमांक</th>
                <th className="border border-black p-2" colSpan="2">प्रकल्पप्रस्ताचे नाव व<br />कुटुंबातील सदस्याचे नाव</th>
                <th className="border border-black p-2" rowSpan="2" style={{ width: '70px' }}>कुटुंबातील<br />सदस्य</th>
                <th className="border border-black p-2" rowSpan="2" style={{ width: '80px' }}>वर्गवारी</th>
                <th className="border border-black p-2" rowSpan="2">शेरा</th>
                <th className="border border-black p-2 noprint" rowSpan="2">क्रिया</th>

              </tr>
              <tr className="font-bold">
                <th className="border border-black p-2">प्रकल्पप्रस्ताशी<br />नाते</th>
                <th className="border border-black p-2" style={{ width: '70px' }}>प्रकल्पप्रस्ताशी<br />नाते</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center font-bold">
                <td className="border border-black p-2">1</td>
                <td className="border border-black p-2">2</td>
                <td className="border border-black p-2">3</td>
                <td className="border border-black p-2">4</td>
                <td className="border border-black p-2">5</td>
                <td className="border border-black p-2">6</td>
                <td className="border border-black p-2">7</td>
                <td className="border border-black p-2">8</td>
                <td className="border border-black p-2">9</td>
              </tr>

              {familyData.map((family, idx) => (
                <React.Fragment key={idx}>
                  {family.members.map((member, mIdx) => (
                    <tr key={`${idx}-${mIdx}`}>
                      {mIdx === 0 && (
                        <>
                          <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.serial}</td>
                          <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.house}</td>
                          <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.jmr}</td>
                          <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.house}</td>
                        </>
                      )}
                      <td className="border border-black p-2">{member.name}</td>
                      <td className="border border-black p-2 text-center">{member.relation}</td>
                      {mIdx === 0 && (
                        <>
                          <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.family}</td>
                           <td className="border border-black p-2 text-center" rowSpan={family.members.length}>{family.category}</td>
                          {/* <td className="border border-black p-2" rowSpan={family.members.length} style={{ fontSize: '15px' }}>
                            {family.remarks}
                          </td> */}
                          {/* <td rowSpan={family.members.length} className="border border-black p-2 text-center">
                            {editingId === family.measureId ? (
                              <input
                                value={editData.category}
                                onChange={(e) => handleEditChange('category', e.target.value)}
                                className="w-full border p-1 text-center"
                              />
                            ) : (
                              family.category || ''
                            )}
                          </td> */}

                          <td rowSpan={family.members.length} className="border border-black p-2">
                            {editingId === family.measureId ? (
                              <textarea
                                value={editData.remarks}
                                onChange={(e) => handleEditChange('remarks', e.target.value)}
                                className="w-full border p-1 resize-none"
                                rows={2}
                              />
                            ) : (
                              family.remarks || ''
                            )}
                          </td>

                          <td rowSpan={family.members.length} className="border border-black p-2 text-center noprint">
                            {editingId === family.measureId ? (
                              <div className="flex gap-2 justify-center">
                                <button
                                  onClick={() => saveEdit(family)}
                                  className="bg-green-500 text-white p-1 rounded hover:bg-green-600"
                                  title="सेव करा"
                                >
                                  <Save size={16} />
                                </button>
                                <button
                                  onClick={cancelEdit}
                                  className="bg-red-500 text-white p-1 rounded hover:bg-red-600"
                                  title="रद्द करा"
                                >
                                  <X size={16} />
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={() => startEdit(family)}
                                className="bg-blue-500 text-white p-1 rounded hover:bg-blue-600"
                                title="संपादित करा"
                              >
                                <Edit2 size={16} />
                              </button>
                            )}
                          </td>

                        </>
                      )}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="mt-10 text-right">
          <div className="font-bold">{fullName}</div>
          <div>{designation}</div>
        </div>

        </div>
      </div>
      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}
    </div>
  );
};

export default Kalam11;